import * as Highcharts from 'highcharts';
import { Injectable } from '@angular/core';
@Injectable()
export class HighchartsService {
  constructor() {
  }

  createChart(el, cfg) {
    Highcharts.chart(el, cfg);
  }


  getHighChartOptions(type, text, lang) {
    const chartOptions = {
      chart: {
        type: type
      },

      tooltip: {
        valueSuffix: ''
      },
      title: {
        text: ''
      },
      xAxis: [{}],
      yAxis: {
        title: {
          text: text
        }
      },
      series: [{}],
      exporting: {
        buttons: {
          contextButton: {
            menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
          }
        }
      }
    };

    if (lang) {
      chartOptions['lang'] = {
        decimalPoint: '.',
        thousandsSep: ','
      }
    }

    return chartOptions
  }

  getHighChartOprionsAmbientandtemp(chartType: String, title: String, yAxisData: Array<any>, plotOptions: boolean, rangeSelector: boolean) {
    const { yAxisConfig, seriesConfig } = this.createDynamicYAxis(yAxisData);
    const chartOptions = {
      chart: {
        type: chartType
      },
      tooltip: {
        valueSuffix: '',
        shared: true,
      },
      title: {
        text: title
      },
      xAxis: [{}],
      yAxis: yAxisConfig, // Dynamically generated yAxis,,
      series: seriesConfig,
      exporting: {
        buttons: {
          contextButton: {
            menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
          }
        }
      }
    };
    if (plotOptions) {
      chartOptions['plotOptions'] = {
        spline: {
          marker: {
            enabled: false
          },
        }
      }
    }

    if (rangeSelector) {
      chartOptions['rangeSelector'] = {
        selected: 1
      }
    }


    return chartOptions;
  }

  createDynamicYAxis(yAxisData) {
    const colors = Highcharts.getOptions().colors; // Default color scheme
    const yAxisConfig = [];
    const seriesConfig = [];
    const keyToCheck = 'showEmpty';

    // Loop over the imported axisData and dynamically generate yAxis configuration
    yAxisData.forEach((axis, index) => {
      let yAxisConfigObj = {
        labels: {
          style: {
            color: colors[index] // Dynamic color based on the provided index
          }
        },
        title: {
          text: axis.title, // Dynamic title from axisData
          style: {
            color: colors[index] // Dynamic color for the title
          }
        },
        opposite: axis.opposite // Dynamically decide if the axis should be on the opposite side
      }

      const keyExistsInObject = keyToCheck in axis;
      if (keyExistsInObject) {
        yAxisConfigObj['showEmpty'] = axis.showEmpty
      }
      yAxisConfig.push(yAxisConfigObj);
      seriesConfig.push({
        name: '',
        yAxis: index,
        data: []
      })

    });
    return { yAxisConfig, seriesConfig };
  }
}

